import { Box, Text, getThemeColor } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const Wrapper = styled(Box)`
  flex: 1;
  min-width: 100%;
  border: 1px solid ${({ theme }) => getThemeColor('grey_4', theme)};
  border-radius: ${({ theme }) => theme.border_radius.card};
  flex-direction: column;

  & > div {
    border-bottom: 1px solid ${({ theme }) => getThemeColor('grey_4', theme)};

    &:last-child {
      border-bottom: none;
    }
  }
`

export const Column = styled(Box)`
  flex-direction: column;
  flex: 1;
  min-width: 100px;
  overflow: hidden;
`

export const ColumnTitle = styled(Text)`
  p {
    font-size: 12px;
    color: ${({ theme }) => getThemeColor('grey_3', theme)};
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`

export const ColumnValue = styled(Text)`
  p {
    font-size: 14px;
    font-weight: 500;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-all;
  }
`
